// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".usage-fees-tokuyo-living-costs-table .title[data-v-60180563]{font-size:18px;font-weight:700}.usage-fees-tokuyo-living-costs-table .validation-label[data-v-60180563]{color:#d94a7d;font-size:10px;border:1px solid #d94a7d;padding:1px 4px 0 4px;margin:2px 6px 4px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
